/*
  Project: druckhaus
  Author: schrittweiter GmbH
 */

import lazy from './modules/lazy';
import cursor from './modules/cursor';
import device from './modules/device';
import video from './modules/video';
import menu from './modules/menu';
import slider from './modules/slider';
import drag from './modules/drag';
import header from './modules/header';
import showcase from './modules/showcase';
import filter from './modules/filter';
import service from './modules/service';
import accordion from './modules/accordion';
import table from './modules/table';
import team from './modules/team';
import anchor from './modules/anchor';
import link from './modules/link';
import hyphen from './modules/hyphen';
import cookie from './modules/cookie';
import search from './modules/search';

device.device();
link();
hyphen();
cursor.markup();
cursor.cursor();
cursor.refresh();
showcase.init();
filter.toggle();
service.list();
video();
menu();
slider();
drag();
header();
lazy();
accordion();
team.list();
table();
anchor.scrollspy();
anchor.scroll();
anchor.toggle();

search.show();
search.fill();
cookie();



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/app.js